export {
  LinkColor,
  LinkHoverColor,
  LinkIconPosition,
  LinkUnderline,
  LinkWeight,
  QueryParams,
} from './link.component';
